import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "arrow-down2--sprite",
  "use": "arrow-down2--sprite-usage",
  "viewBox": "0 0 17 16",
  "content": "<symbol viewBox=\"0 0 17 16\" xmlns=\"http://www.w3.org/2000/svg\" id=\"arrow-down2--sprite\">\n<path d=\"M13.8334 7.99999L12.8934 7.05999L9.16675 10.78V2.66666H7.83341V10.78L4.11341 7.05332L3.16675 7.99999L8.50008 13.3333L13.8334 7.99999Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol